/* global loggedInUser */
const userRegistration = (function () {
  'use strict';
  const accMgrForm = document.querySelector('[id*="page_account_manager_"]');
  const bannerTitle = document.querySelector('.page-banner__title');

  if (accMgrForm) {
    if (loggedInUser && bannerTitle) {
      bannerTitle.innerHTML = 'My Account';
      document.title = document.title.replace(/^[^|]+/, 'My Account ');
    }
  }
})();

export default userRegistration;
